import Box from "ds/components/Box";
import Button from "ds/components/Button";
import Callout from "ds/components/Callout";
import Typography from "ds/components/Typography";
import Timestamp from "components/Timestamp";

import { useAccountDeletion } from "./AccountDeletion/useAccountDeletion";

const SettingsAccountDeleteWarning = () => {
  const {
    isAccountDeletionAvailable,
    markedForDeletion,
    accountCanBeDeleted,
    accountCanBeDeletedAt,
    toggleForDeletionMark,
    loadingMarking,
  } = useAccountDeletion();

  if (!isAccountDeletionAvailable || !markedForDeletion || !accountCanBeDeletedAt) {
    return null;
  }

  return (
    <Callout variant="danger" title="Account marked for deletion">
      <Box direction="column" gap="medium">
        <Typography variant="p-body3" tag="p">
          {accountCanBeDeleted ? (
            "You may now permanently delete this account and all associated data. This action cannot be undone."
          ) : (
            <>
              New runs are blocked. Deletion will be available on{" "}
              <Timestamp timestamp={accountCanBeDeletedAt} variant="p-t7" />. If this action is no
              longer intended, you can cancel using the "Do not delete" button.
            </>
          )}
        </Typography>
        <Box direction="row">
          <Button
            variant="secondary"
            size="small"
            onPress={toggleForDeletionMark}
            loading={loadingMarking}
            disabled={loadingMarking}
          >
            Do not delete
          </Button>
        </Box>
      </Box>
    </Callout>
  );
};

export default SettingsAccountDeleteWarning;
